import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onRegisterCard, onViewActivity }) => {
  const actions = [
    {
      title: 'Register New Card',
      description: 'Add a new NFC card to the system',
      icon: 'Plus',
      variant: 'primary',
      onClick: onRegisterCard
    },
    {
      title: 'View Recent Activity',
      description: 'Check latest card transactions and updates',
      icon: 'Activity',
      variant: 'outline',
      onClick: onViewActivity
    },
    {
      title: 'Generate Report',
      description: 'Create billing and usage reports',
      icon: 'FileText',
      variant: 'outline',
      onClick: () => window.location.href = '/reports-analytics'
    },
    {
      title: 'Manage Users',
      description: 'Add or modify user accounts',
      icon: 'Users',
      variant: 'outline',
      onClick: () => window.location.href = '/user-management'
    }
  ];

  return (
    <div className="bg-surface border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-text-primary mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {actions.map((action, index) => (
          <div key={index} className="group">
            <Button
              variant={action.variant}
              onClick={action.onClick}
              iconName={action.icon}
              iconPosition="left"
              className="w-full justify-start p-4 h-auto"
            >
              <div className="text-left">
                <div className="font-medium">{action.title}</div>
                <div className="text-sm text-text-muted mt-1">{action.description}</div>
              </div>
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;